<template>
  <div class="p-grid data-table data-table-list">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <div class="p-col-12">
      <div class="card card-w-title">
        <DataTable
          :value="purchases"
          class="p-datatable-responsive"
          :paginator="true"
          :rows="10"
          :filters="filters"
          :autoLayout="true"
          ref="admin_purchases"
        >
          <template #header>
            <h2>List of bitcoin purchases</h2>
            <Button class="export-button" icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
          </template>
          <Column field="package_name" header="Package" :sortable="true">
            <template #body="slotProps">
              <span class="name">{{ slotProps.data.package_name }}</span>
            </template>
          </Column>
          <Column field="amount" header="Amount" :sortable="true">
            <template #body="slotProps">
              <span class="status">{{ formatCurrency(slotProps.data.amount) }}</span>
            </template>
          </Column>
          <Column field="time" header="Time of purchase" :sortable="true">
            <template #body="slotProps">
              <span class="time">{{ formatDate(slotProps.data.time) }}</span>
            </template>
          </Column>
          <Column field="status" header="Status" :sortable="true">
            <template #body="slotProps">
              <span class="status">{{ slotProps.data.status }}</span>
            </template>
          </Column>
          <Column field="transaction_hash" header="Transaction hash" :sortable="true" >
            <template #body="slotProps">
              <span>{{ slotProps.data.transaction_hash }}</span>
            </template>
          </Column>
          <Column field="actions" header="Actions" :sortable="true">
            <template #body="slotProps">
              <Button class="btn-primary" label="Show details" @click="openDialog(slotProps.data)" />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>

    <Dialog :header="title" :visible.sync="display" :style="{width: '50vw'}" :modal="true">
      <div class="content-data">
        <h4>Purchase data</h4>
        <div class="data-item">
          <p>Name</p>
          <p>{{ activeRow.name }} {{ activeRow.surname }}</p>
        </div>
        <div class="data-item">
          <p>Package</p>
          <p>{{ activeRow.package_name }}</p>
        </div>
        <div class="data-item">
          <p>Time of pruchase</p>
          <p>{{ formatDate(activeRow.time) }}</p>
        </div>
        <div class="data-item">
          <p>Status</p>
          <p>{{ activeRow.status }}</p>
        </div>
        <div class="data-item">
          <p>Payment type</p>
          <p>{{ activeRow.payment_type }}</p>
        </div>
        <div class="data-item">
          <p>Voucher</p>
          <p>{{ activeRow.voucher_id }}</p>
        </div>
        <div class="data-item">
          <p>Amount</p>
          <p>{{ activeRow.amount }}</p>
        </div>
        <div class="data-item">
          <p>Bank Account</p>
          <p>{{ activeRow.bank_account }}</p>
        </div>
        <div class="data-item">
          <p>BTC amount</p>
          <p>{{ activeRow.btc_amount }}</p>
        </div>
        <div class="data-item">
          <p>Wallet address</p>
          <p>{{ activeRow.wallet_address }}</p>
        </div>
        <div class="data-item">
          <p>Transaction Hash</p>
          <p>{{ activeRow.transaction_hash }}</p>
        </div>
      </div>
      <template #footer>
        <div class="p-grid">
          <div class="p-md-6 p-offset-6">
            <Button
              v-if="activeRow.status !== 'approved'"
              label="Approve"
              @click="purchaseApprove(activeRow.id)"
              icon="pi pi-check"
              class="p-button-success"
            />
            <Button
              v-if="activeRow.status == 'pending'"
              label="Deny"
              @click="purchaseDeny(activeRow.id)"
              icon="pi pi-times"
              class="p-button-danger"
            />
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import PurchaseService from "../../../service/PurchaseService";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      purchases: null,
      editingCellRows: {},
      editingRows: [],
      filters: {},
      activeRow: {},
      display: false,
      title: "",
      isLoading: false,
      message: "Test message"
      // columns: null
    };
  },
  created() {
    this.$store.commit('setPageTitle', {pageTitle: 'BTC Purchases'});
    this.purchaseService = new PurchaseService();
    this.originalRows = {};
    if (this.$route.params.purchase) {
      this.filters["transaction_hash"] = this.$route.params.purchase.tx_id; //filter
    }
  },
  components: {
    Loading
  },
  async mounted() {
    this.purchaseService
      .listBTCPurchases(this.$store.state.currentUser.token)
      .then(data => (this.purchases = data))
  },
  methods: {
    async purchaseApprove(purchase_id) {
      this.isLoading = true;
      await this.purchaseService.approvePurchase(purchase_id);
      this.purchases = await this.purchaseService.listBTCPurchases(
        this.$store.state.currentUser.token
      );
      this.closeDialog();
      this.isLoading = false;
    },
    async purchaseDeny(purchase_id) {
      this.isLoading = true;
      await this.purchaseService.denyPurchase(purchase_id, this.message);
      this.purchases = await this.purchaseService.listBTCPurchases(
        this.$store.state.currentUser.token
      );
      this.closeDialog();
      this.isLoading = false;
    },
    formatDate(date) {
      console.log(this.purchases)

      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        hours = "" + d.getHours(),
        mins = "" + d.getMinutes();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      if (hours.length < 2) hours = "0" + hours;
      if (mins.length < 2) mins = "0" + mins;

      return [year, month, day].join("-") + " " + hours + ":" + mins;
    },
    formatCurrency(value) {
        return new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR",
        }).format(value);
    },
    openDialog(purchase) {
      this.display = true;
      this.activeRow = purchase;
      this.title =
        "Pending purchase for user: " + purchase.name + " " + purchase.surname;
    },
    closeDialog() {
      this.display = false;
      this.documents = [];
    },
    exportCSV() {
      this.$refs.admin_purchases.exportCSV();
    }
  }
};
</script>

<style scoped>
</style>